export default "__VITE_ASSET__Cemz1YLv__"